"use client"
import { useState, type ReactNode } from "react"
import { ChevronDown } from "lucide-react"

export function AccordionField({
  label,
  children,
}: { label: string; children?: ReactNode }) {
  const [open, setOpen] = useState(false)

  return (
    <div className="border border-gray-300/50 rounded-xl bg-white/70 backdrop-blur-sm overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between px-3 py-2 font-normal text-gray-700 hover:bg-gray-100/50 transition-colors"
      >
        <span>{label}</span>
        <ChevronDown className={`h-5 w-5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="px-3 pb-3 text-sm text-gray-700 whitespace-pre-line">
          {children ?? "Sin información adicional."}
        </div>
      )}
    </div>
  )
}
